import { render, staticRenderFns } from "./snackbarMessage.vue?vue&type=template&id=4fe5138a"
import script from "./snackbarMessage.vue?vue&type=script&lang=js"
export * from "./snackbarMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports